import * as routes from './routes';

// backend cookie
export const PZCOOKIESESSION = 'PZCOOKIESESSION';

// context
export const UNEXPECTED_ERROR = '未知错误';
export const BROWSER_SUPPORTED_TEXT =
  '出于安全和用户隐私的考量，请您下载使用最新版本的Chrome或Edge或Safari浏览器再访问本网站以获得更好的使用体验。';
export const MOBILE_SUPPORTED_TEXT =
  '出于安全和用户隐私的考量，请您在电脑中下载使用最新版本的Chrome或Edge或Safari浏览器再访问本网站以获得更好的使用体验。';

export const BROWSER_SUPPORTED_TITLE = '浏览器不支持';
export const ROUTER_NOT_EXIST = '您要访问的路径不存在';

// global configurations
export const NOTE_CONTENT_MAX_LENGTH = 8000;
export const DEBOUNCE_LATENCY = 1000;
export const HALF_DEBOUNCE_LATENCY = 500;
export const FIREWORKS_LATENCY = 3000;
export const SHOOL_LATENCY = 1000;

export const CURRENT_VERSION = '1.0.1';

export const MOBILE_TIMER = 60;

export const DEFAULT_DATA_URL_DATA = 'R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA';
export const DEFAULT_DATA_URL = 'data:image/gif;base64,' + DEFAULT_DATA_URL_DATA;

// eslint-disable-next-line
export const RE_EMAIL = new RegExp('^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$');
export const RE_ALL_NUMBER = new RegExp('^[0-9]+$');
export const RE_NUMBER = new RegExp('[0-9]+');
export const RE_LETTER = new RegExp('[A-Za-z]+');

export const SERVER_ROOT_DOMAIN = 'pzacademy.com';
export const URL_WWW_PZ_ACADEMY_COM = `www.pzacademy.com`;
export const URL_CLASS_PZ_ACADEMY_COM = `class.pzacademy.com`;
export const URL_CLASS_PZ_ACADEMY_COM_DEV = 'my2.pzacademy.com:8000';
export const URL_MP_PZ_ACADEMY_COM = 'mp.pzacademy.com';
export const URL_MP_PZ_ACADEMY_COM_DEV = 'my.pzacademy.com/pz-wechat';
export const URL_WECHAT_CALLBACK_PZ_ACADEMY_COM = 'class.pzacademy.com';
export const APP_ID_OPEN = 'wx19f6ca1a6546a856';
export const APP_ID_MP = 'wxf38c89b82486abee'; //'wxef9f5d3d84e3276a';
export const APP_ID_OPEN_DEV = 'wx95e32df3925a69ce';
export const APP_ID_MP_DEV = 'wxd11818d37dbd2ae5';
export const STATE_WEB = 'STATE_WEB';
export const STATE_MP = 'STATE_MP';
export const OSS_TIMER = 1000 * 60;
export const BROADCAST_COURSE_ID = '19598';
export const FREE_COURSE_ID = '20426';
export const TRAIL_COURSE_ID = '20426';
export const SCHEME_COURSE_ID = '?';
export const GOOD_ID_MAP = {
  cfa1: 1,
  cfa2: 2,
  cfa3: 3,
  frm1: 4,
  frm2: 5,
  other: 6,
  coupon: 7,
};
export const EVENT_URL = `activity.${SERVER_ROOT_DOMAIN}/index/activity/event`;
export const EVENT_TYPE_URL = `activity.${SERVER_ROOT_DOMAIN}`;
export const ARTICLES_PAGE = `${window.location.protocol}//www.${SERVER_ROOT_DOMAIN}/articles`;

export const HTTPS_URL_WWW_PZ_ACADEMY_COM = `https://www.pzacademy.com`;

export const REDIRECT_URLS = {
  LANDING_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.LANDING_PAGE,
  MALL_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.MALL_PAGE,
  TEACHERS_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.TEACHERS_PAGE,
  ARTICLES_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + '/articles',
  LEGAL_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.LEGAL_PAGE,
  ABOUT_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.ABOUT_PAGE,
  PRIVACY_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.PRIVACY_PAGE,
  READER_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.READER_PAGE,
  QA_QUESTION_LIST_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + routes.READER_PAGE,
  TO404_PAGE: HTTPS_URL_WWW_PZ_ACADEMY_COM + '/404',
};

export * from './pageChunk';
export * from './store';
